var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-header-top-div",staticStyle:{"margin-bottom":"15px"}},[_c('div',{staticStyle:{"overflow-x":"auto"}},[_c('el-table',{attrs:{"data":_vm.tableData}},_vm._l((_vm.tableColumns),function(col){return _c('el-table-column',{key:col.key,attrs:{"label":_vm.$t(col.label),"prop":col.key,"render-header":_vm.renderHeader}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }